import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import FindForm from "./FindForm";

class RequisitesFindForm extends React.Component {
  render() {
    return (
      <FindForm dataItem={this.props.requisitesFindItem}
                dataItemParams={this.props.requisitesFindItemParams}
                row={this.props.TLRow}
                title={i18next.t("FindRequisitesTitle")}
                onClose={this.props.onClose}
                onSelect={this.props.onSelectRequisites}
      />
    );
  }
}

RequisitesFindForm.propTypes = {
  TLRow: PropTypes.object,
  onSelectRequisites: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,

  dispatch: PropTypes.func,
  requisitesFindItem: PropTypes.object,
  requisitesFindItemParams: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  return {
    requisitesFindItem: state.transportState.requisitesFindItem,
    requisitesFindItemParams: state.transportState.requisitesFindItemParams
  };
}

export default connect(mapStateToProps)(RequisitesFindForm);